import { useReportContext } from "../report-context";

import { useColumnEvents } from "./hooks/useColumnEvents";
import { useTableConfiguration } from "./hooks/useTableConfiguration";
import { FormattedTableProps } from "./types";
import { FormattedTableContent } from "./FormattedTableContent";

export const FormattedTable = (props: FormattedTableProps) => {
  const reportContext = useReportContext();
  const { reportId } = reportContext;

  const { handleColumnMoved } = useColumnEvents(reportId);
  const { gridContextStorageKey, gridContextCustomActions, sideBar, rowNumbers } =
    useTableConfiguration();

  return (
    <FormattedTableContent
      {...props}
      onColumnMoved={handleColumnMoved}
      gridContextStorageKey={gridContextStorageKey}
      gridContextCustomActions={gridContextCustomActions}
      sideBar={sideBar}
      rowNumbers={rowNumbers}
    />
  );
};

export default FormattedTable;
